/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import './ForgotPassword.css';
import { Link } from 'react-router-dom';
import BaseCom from './BaseCom';
import FormInput from './FormInput';
import L from './Lang';
import { qreq } from '../shared/qrequest';
import Alert from './Alert';
import Auth from '../shared/Auth';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import Icon from './Icon';

class ForgotPassword extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: { ...props.info },
            submitting: false,
            success: false
        };

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        Auth.getLogin(u => {
            if (u)
                this.props.navigate('/console');
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show)
            this.setState({ info: { ...this.props.info } });

        if (prevProps.info !== this.props.info)
            this.setState({ info: { ...this.props.info } });
    }

    submit(e) {
        e.preventDefault();

        this.setState({ submitting: true });

        qreq.post('/api/auth/forgot-password', this.state.info, j => {
            if (j.errorCode === 0)
                this.setState({ success: true });
            else
                this.alert(j.errorMessage);

            this.setState({ submitting: false });
        }, () => {
            this.alert(<L>Unknown error occurred, please try again.</L>);
            this.setState({ submitting: false });
        });
    }

    render() {
        return (
            <section className="forgot-password-page">
                <div className="forgot-password-bg" />

                <div className="container-fluid forgot-password-container">
                    <div className="row justify-content-center align-items-center min-vh-100">
                        <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
                            <div className="forgot-password-card">
                                <div className="forgot-password-icon">
                                    <Icon icon={this.state.success ? 'faCheck' : 'faLock'} />
                                </div>

                                {this.state.success ? <>
                                    <h1 className="forgot-password-title"><L>Check Your Email</L></h1>
                                    <p className="forgot-password-subtitle">
                                        <L>An email has been sent to</L> <strong>{this.state.info.email}</strong> <L>with further instructions.</L>
                                    </p>

                                    <div className="forgot-password-success-box">
                                        <Icon icon="faEnvelope" />
                                        <span><L>Follow the link in the email to reset your password.</L></span>
                                    </div>
                                </> : <>
                                    <h1 className="forgot-password-title"><L>Forgot Password?</L></h1>
                                    <p className="forgot-password-subtitle">
                                        <L>Enter your email address and we will send you instructions to reset your password.</L>
                                    </p>

                                    <form onSubmit={this.submit} className="forgot-password-form">
                                        <FormInput
                                            model={this.state.info}
                                            name="email"
                                            label="Email Address"
                                            type="email"
                                            required={true}
                                            labelAsPlaceholder={true}
                                            className="mt-2"
                                            autoComplete="email"
                                        />

                                        {this.state.error ? (
                                            <Alert message={this.state.error} type="danger" className="mt-3" />
                                        ) : ''}

                                        <div className="d-grid mt-4">
                                            <button type="submit" className="btn btn-primary btn-lg forgot-password-submit" disabled={this.state.submitting}>
                                                {this.state.submitting ? <>
                                                    <Icon icon="faRefresh" className="spinner" /> <L>Sending...</L>
                                                </> : <>
                                                    <Icon icon="faEnvelope" /> <L>Send Reset Link</L>
                                                </>}
                                            </button>
                                        </div>
                                    </form>
                                </>}

                                <div className="forgot-password-footer">
                                    <Link to={this.props.client ? '/client/login' : '/login'}>
                                        <Icon icon="faArrowLeft" /> <L>Back to Login</L>
                                    </Link>
                                </div>
                            </div>

                            <p className="forgot-password-note">
                                <L>For security, reset links may expire after a short period of time.</L>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withParamsAndNavigate(ForgotPassword);
